import { initContract } from "@ts-rest/core";
import {
	AuthTokensDto,
	googleLoginInput,
	emailLoginInput,
} from "../validators/auth.validator";
import { CreatedUserDetailsDto } from "../validators/users.validator";
import {
	GenerateOtpDto,
	generateOtpInput,
} from "../validators/generate-otp.validators";
import {
	ChangePassworResponseDto,
	changePasswordInput,
} from "../validators/change-password.validators";
import { z } from "zod";

const c = initContract();

export const authContract = c.router({
	google: {
		method: "POST",
		path: "/auth/login",
		responses: {
			200: c.type<AuthTokensDto>(),
		},
		body: googleLoginInput,
		summary: "Login using Google auth code",
	},
	emailLogin: {
		method: "POST",
		path: "/auth/login",
		responses: {
			200: c.type<AuthTokensDto>(),
		},
		body: emailLoginInput,
		summary: "Login using email and password",
	},
	me: {
		method: "GET",
		path: "/auth/me",
		responses: {
			200: c.type<CreatedUserDetailsDto>(),
		},
		summary: "Get the details of the current logged in user",
	},
	OTP: {
		method: "POST",
		path: "/auth/generate-otp",
		responses: {
			200: c.type<GenerateOtpDto>(),
		},
		body: generateOtpInput,
		summary: "Generate OTP",
	},
	changePassword: {
		method: "POST",
		path: "/auth/change-password",
		responses: {
			200: c.type<ChangePassworResponseDto>(),
		},
		body: changePasswordInput,
		summary: "Change Password",
	},
	accountActivate: {
		method: "POST",
		path: "/auth/activate",
		body: z.void(),
		responses: {
			204: c.type<void>(),
		},
		query: z.object({
			token: z.string(),
		}),
	},
});
